import { useOrganization } from '../api/Onboarding';
import useAuth from '../auth/useAuth';
import { OrganizationType } from '../constants';

export default function useOrganizationType() {
  const { isLoading: authLoading } = useAuth();
  const { data: organization, isLoading: organizationLoading } = useOrganization();

  // Determnine if self-serve enabled based on account type
  const isProAccount = organization?.data.account_type === OrganizationType.PRO;
  const isHybridAccount = organization?.data.account_type === OrganizationType.HYBRID;
  const isMagicAccount = organization?.data.account_type === OrganizationType.MAGIC;

  return {
    isProAccount,
    isHybridAccount,
    isMagicAccount,
    isLoading: organizationLoading || authLoading,
  };
}
